import { useEffect } from 'react';
import { setItem, getItem, removeItem } from 'Helpers/sessionStorage';
import { PRICE_CARD_TAB_EXPERIMENT } from 'Constants/items';
import { useExperiment } from 'LaquesisEOL/useExperiment';
import { SHOW_PRICE_CARD_TABS } from 'Constants/priceCardTabs';

/** Toggle the flag value for the price card tab experiment */
const usePriceCardTabsExperiment = () => {
    const priceCardTabVariant = useExperiment(PRICE_CARD_TAB_EXPERIMENT || '');

    useEffect(() => {
        if (priceCardTabVariant && !getItem(SHOW_PRICE_CARD_TABS)) {
            setItem(SHOW_PRICE_CARD_TABS, true);
        }
        else if (!priceCardTabVariant && getItem(SHOW_PRICE_CARD_TABS)) {
            removeItem(SHOW_PRICE_CARD_TABS);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default usePriceCardTabsExperiment;
